import VueJwtDecode from "vue-jwt-decode";
import { loadGapiInsideDOM, gapi } from "gapi-script";

const CLIENT_ID =
  "66644696787-hmbgig233fg0026p1hs0qctki5p06pr7.apps.googleusercontent.com";

export const GoogleSignInMod = () => {
  if (!CLIENT_ID) {
    console.log("no client id was found");
    return;
  }
  return new Promise((resolve, reject) => {
    loadGapiInsideDOM().then(() => {
      gapi.load("auth2", () => {
        gapi.auth2
          .init({
            client_id: CLIENT_ID,
          })
          .then(() => {
            gapi.auth2
              .getAuthInstance()
              .signIn({ prompt: "select_account" })
              .then((googleUser) => {
                const profile = googleUser.getBasicProfile();
                const authResponse = googleUser.getAuthResponse();

                resolve({
                  id_token: authResponse.id_token,
                  profile: {
                    email: profile.getEmail(),
                    name: profile.getName(),
                    imageUrl: profile.getImageUrl(),
                  },
                });
              });
          })
          .catch((error) => {
            reject(error);
          });
      });
    });
  });
};

export function isTokenExpired(token) {
  try {
    const decoded = VueJwtDecode.decode(token);
    if (decoded) {
      return decoded.exp * 1000 < Date.now();
    }
  } catch (error) {
    console.error("Failed to decode token", error);
    return true;
  }
}
